import './Background.css';
import { ATMOSPHERE_BACKGROUND_URLS } from '../atmosphereAssets';

export type BackgroundVariant = 'welcome' | 'delivery';

export type BackgroundProps = {
  variant?: BackgroundVariant;
};

/** Full-bleed screen background (`welcome` or `delivery` art). */
export function Background({ variant = 'welcome' }: BackgroundProps) {
  return (
    <img
      className="background"
      src={ATMOSPHERE_BACKGROUND_URLS[variant]}
      alt=""
      draggable={false}
    />
  );
}
